module.exports = __webpack_public_path__ + "img/top-left-arrow.946a95e.svg";